import {
  faSearch
} from "@fortawesome/pro-regular-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DateDisplay, TimeDisplay } from "components/Shared/DateDisplay";

import React, { useState, } from "react";
import { AvailableFareConnectionModel, AvailableFareModel } from "WebApiClient";
import { AllotmentModal } from "./Fare.AllotmentInfo";
import moment from "moment";
import _ from "lodash";
import { RenderWaitlist } from "./RenderWaitlist";
import { RenderBaggage } from "./RenderBaggage";
import { RenderFlightInfo } from "./RenderFlightInfo";
import { RenderIncludedServices } from "./RenderIncludedServices";
import { RenderUpsellContent } from "./RenderUpsellContent";
moment().format();

interface OwnProps {
  Data: AvailableFareConnectionModel;
  SelectedConnection: any;
  GetSelectedConnectionIndexByLegIndex: any;
  LegIndex: number;
  ConnectionIndex: number;
  SelectConnection: (legIndex: number, connectionIndex: number) => void;
  IsWebFare: boolean;
  connectionAppliesToFilter: boolean;
  Fare: AvailableFareModel;
  connection: any;
  cabinIsPresentAll: boolean | undefined;
  headerOffVisible: boolean;
}


const FareLegConnectionTableRow: React.FC<OwnProps> = (props) => {
  const [AllotmentModalOpen, setAllotmentModalOpen] = useState(false);

  function SegmentHasAllotment() {
    let result = false;
    props.Data.segments.forEach((seg) => {
      if (seg.allotmentInformation) {
        result = true;
      }
    });
    return result;
  }

  function ToggleAllotmentModal() {
    setAllotmentModalOpen(!AllotmentModalOpen);
  }

  function OnConnectionSelection() {
    if (props.connectionAppliesToFilter) {
      props.SelectConnection(props.LegIndex, props.ConnectionIndex);
      props.GetSelectedConnectionIndexByLegIndex(props.ConnectionIndex);
      props.GetSelectedConnectionIndexByLegIndex(props.LegIndex);
    }
  }


  return (
    <React.Fragment>
      {props.headerOffVisible != false &&
        <tr className={props.connectionAppliesToFilter ? "" : "table-inactive"}>
          <>
            <td style={{ width: "1%" }}
              className="text-center"
              onClick={OnConnectionSelection}
            >
              {/* SELECT  */}
              {props.connectionAppliesToFilter && (
                <div className="custom-control custom-radio">
                  <input
                    onChange={() => { }}
                    className="form-check-input rbConnectionSelect"
                    type="radio"
                    checked={props.ConnectionIndex === props.SelectedConnection}
                  />
                  <label className="form-check-label">&zwnj;</label>
                </div>
              )}
            </td>
            <td className="text-truncate" onClick={OnConnectionSelection}>

              {props.Data.segments!.map((segment, index) => (
                <span key={segment.departureAirport.iata + segment.arrivalAirport.iata + segment.index}>
                  <span>{segment.departureAirport!.iata}</span>-
                  <span>{segment.arrivalAirport!.iata}</span>
                  <br />
                </span>
              ))}
            </td>
          </>

          <td className="text-truncate" onClick={OnConnectionSelection}>
            {/* FLIGHT */}
            <RenderFlightInfo segments={props.Data.segments} />
          </td>
          <>
            <td className="text-truncate" onClick={OnConnectionSelection}>
              {" "}
              {/* TYPE  */}
              {props.Data.segments!.map((segment, index) => (
                <span key={"props.Data.segments2" + index}>
                  <span>{segment.equipmentCode}</span>
                  <br />
                </span>
              ))}
            </td>

            <td className="text-truncate" onClick={OnConnectionSelection}>
              {" "}
              {/* DATES  */}
              {props.Data.segments!.map((segment, index) => (
                <span key={"props.Data.segments3" + index}>
                  <span>
                    <DateDisplay date={segment.departureDate} />
                  </span>
                  <br />
                </span>
              ))}
            </td>

            <td className="text-truncate" onClick={OnConnectionSelection}>
              {" "}
              {/* TIMES  */}
              {props.Data.segments!.map((segment, index) => (
                <span key={"props.Data.segments4" + index}>
                  <span>
                    <span>
                      <TimeDisplay date={segment.departureDate} /> -{" "}
                    </span>
                    <span>
                      <TimeDisplay date={segment.arrivalDate} />
                      <span className="nextday">
                        {" "}
                        <sup>{segment.dayIndicator}</sup>
                      </span>
                    </span>
                  </span>
                  <br />
                </span>
              ))}
            </td>

            <td className="text-truncate" onClick={OnConnectionSelection}>
              <RenderWaitlist segments={props.Data.segments} />
            </td>
          </>

          <td className="text-truncate" onClick={OnConnectionSelection}>
            {/* BAGGAGE */}
            <RenderBaggage segments={props.Data.segments} />
          </td>

          <td>
            {" "}
            {/* INCLUDEDSERVICES  */}
            <RenderIncludedServices segments={props.Data.segments} />
          </td>

          {SegmentHasAllotment() && (
            <td className="text-center align-middle clickme">
              {" "}
              {/* DETAILS  */}
              <button onClick={ToggleAllotmentModal} className="btn btn-sm">
                <FontAwesomeIcon icon={faSearch} />
              </button>
            </td>
          )}
        </tr>
      }
      {
        props.headerOffVisible == false && (
          <RenderUpsellContent
            segments={props.Data.segments}
            fare={props.Fare}
            connection={props.connection}
            legIndex={props.LegIndex}
          />
        )
      }

      <AllotmentModal
        connection={props.Data}
        isopen={AllotmentModalOpen}
        toggle={ToggleAllotmentModal}
      />
    </React.Fragment>
  );
};

export default FareLegConnectionTableRow;

